import { Row, Col, Spin } from "antd";
import { HeaderUser } from "../../components/HeaderUser";
import { FormattedMessage } from "react-intl";
import { useEffect, useState } from "react";
import moment from "moment";

import {
  getTranslatedValue,
  getMuiTheme,
  getDayNameAndDay,
  getLanguage,
} from "../../utils/Utils";

import { toGetListOfAssessment } from "../../utils/APIs";
import { LoadingOutlined } from "@ant-design/icons";
import { ThemeProvider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import ScreenLoader from "../../components/ScreenLoader";

const language = getLanguage();
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const HistoryAdmin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [loadingData, setLoadingData] = useState(true);
  const [list, setList] = useState([]);
  const [listAll, setListAll] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    var localLocale = moment();

    localLocale.locale("fr"); // set this instance to use French
    localLocale.format("LLLL");

    getdata(10, "", {}, 0);
    getAll();
  }, []);

  const getdata = (rowsPerPage, searchText, filter, pageNb) => {
    setRowsPerPage(rowsPerPage);
    setLoadingData(true);
    toGetListOfAssessment(
      rowsPerPage,
      searchText,
      filter,
      pageNb,
      language,
      false
    ).then((d) => {
      getList(d.res);
      setTotal(d.total);
      setPage(pageNb);
      setLoadingData(false);
    });
  };
  const getAll = async (search, order) => {
    var res = [];

    await toGetListOfAssessment(0, search, order, 0, language, true).then(
      (d) => {
        d.res.forEach((row, key) => {
          var elements = [];
          elements.push(row.clinicName);
          elements.push(row.doctorName);
          elements.push(row.countryName);
          elements.push(row.speciality);
          elements.push(row.dateCreation);
          elements.push(row.email);
          elements.push(null);
          elements.push(row.id);
          res.push({ index: key, data: elements });
        });
        setListAll(res);
      }
    );
  };

  const columns = [
    {
      field: "clinicName",
      headerName: getTranslatedValue("clinicName"),
      flex: 1,
      filterable: true,
      sortable: true,
    },
    {
      field: "doctorName",
      headerName: getTranslatedValue("doctorName"),
      flex: 1,
      filterable: true,
      sortable: true,
    },
    {
      field: "countryName",
      headerName: getTranslatedValue("country"),
      flex: 1,
      filterable: true,
      sortable: true,
    },

    {
      field: "dateCreation",
      headerName: getTranslatedValue("dateGenerationNoBR"),
      flex: 1,
      filterable: true,
      sortable: true,
    },
    {
      field: "email",
      headerName: getTranslatedValue("user"),
      flex: 1,
      filterable: true,
      sortable: true,
    },

    {
      field: "action",
      headerName: "",
      flex: 1,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            margin: "auto",
            textAlign: "right",
            alignItems: "center",
          }}
          onClick={() =>
            navigate("/results", {
              state: { id: params.row.id },
            })
          }
        >
          <img
            style={{ width: "1.5vh" }}
            src="/images/icons/next.svg"
            className="roi--cursor"
            alt="next"
          />
        </div>
      ),
    },
  ];

  const getDuplicate = (duplicate) => {
    return duplicate == true
      ? getTranslatedValue("yes")
      : getTranslatedValue("no");
  };

  const getList = (res) => {
    res.forEach((element) => {
      element.dateCreation =
        null != element.dateCreation
          ? getDayNameAndDay(element.dateCreation)
          : "";

      element.duplicate = getDuplicate(element.duplicate);
    });
    setList(res.filter((el) => el.status == 0 || el.status == 1));

    setLoading(false);
  };

  return (
    <>
      {loading && <ScreenLoader />}
      <HeaderUser />
      <Row>
        <Col
          span={24}
          className="roi--settings-title"
          style={{ marginTop: "1.5vh", textAlign: "center" }}
        >
          <span style={{ marginLeft: "1vh" }}>
            <FormattedMessage id="listOfAssessments" />
          </span>
        </Col>
      </Row>
      <div style={{ marginTop: "5vh" }}>
        <ThemeProvider theme={getMuiTheme()}>
          <DataGrid
            rows={list}
            columns={columns}
            // pageSize={rowsPerPage}
            components={{ Toolbar: GridToolbar }}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10]}
            rowCount={total}
            page={page}
            // rowHeight={38}
            // showToolbar
            disableSelectionOnClick
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                color: "#54596E !important",
                fontSize: "20px !important",
                lineHeight: "20px !important",
                fontStyle: "normal !important",
                textTransform: "uppercase",
                fontFamily: "Gotham",
                textAlign: "center",
              },
              "& .MuiDataGrid-cell": {
                backgroundColor: "#F5F8FA",
                color: "#54596E",
                fontSize: "20px",
                lineHeight: "20px",
                fontStyle: "normal",
                fontWeight: "normal",
                fontFamily: "Gotham",
                textAlign: "center",
              },
            }}
          />
        </ThemeProvider>
      </div>
    </>
  );
};
export default HistoryAdmin;
